var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOptionsVertical = function SvgOptionsVertical(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 8.00033C6.66683 8.73671 7.26378 9.33366 8.00016 9.33366C8.73654 9.33366 9.3335 8.73671 9.3335 8.00033C9.3335 7.26395 8.73654 6.66699 8.00016 6.66699C7.26378 6.66699 6.66683 7.26395 6.66683 8.00033Z",
    fill: "#A4A5AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 4.00033C6.66683 4.73671 7.26378 5.33366 8.00016 5.33366C8.73654 5.33366 9.3335 4.73671 9.3335 4.00033C9.3335 3.26395 8.73654 2.66699 8.00016 2.66699C7.26378 2.66699 6.66683 3.26395 6.66683 4.00033Z",
    fill: "#A4A5AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 12.0003C6.66683 12.7367 7.26378 13.3337 8.00016 13.3337C8.73654 13.3337 9.3335 12.7367 9.3335 12.0003C9.3335 11.2639 8.73654 10.667 8.00016 10.667C7.26378 10.667 6.66683 11.2639 6.66683 12.0003Z",
    fill: "#A4A5AA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOptionsVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "options-vertical.401038700e25bced3ef4a01edbb32522.svg";